// extracted by mini-css-extract-plugin
export default {"container":"Table_container__YmQNy","table_header":"Table_table_header__pZOwQ","cell_text":"Table_cell_text__bKJUw"};